<div class="patients-page">

  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-person me-2"></i>Pacientes</h2>
      <p class="text-muted mb-0">Cadastre e gerencie informações dos seus pacientes</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-person-plus-fill me-1"></i> Novo Paciente
    </button>
  </div>
  <hr/>

  <!-- Barra de filtros -->
  <div class="filter-bar">
    <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Buscar por nome, e-mail, telefone, CPF..."
             (input)="onSearch($any($event.target).value)" />
    </div>
    <select [(ngModel)]="filter.isActive" (change)="filter.page=1; load()">
      <option [ngValue]="true">Ativos</option>
      <option [ngValue]="false">Inativos</option>
      <option [ngValue]="undefined">Todos</option>
    </select>
  </div>

  <!-- Loading -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner-border text-primary"></div>
  </div>

  <!-- Tabela -->
  <div class="table-card" *ngIf="result && !loading">
    <table class="data-table">
      <thead>
        <tr>
          <th (click)="sortBy('name')" class="sortable">
            Nome <i class="bi" [class]="sortIcon('name')"></i>
          </th>
          <th>Telefone</th>
          <th>E-mail</th>
          <th (click)="sortBy('createdAt')" class="sortable">
            Cadastro <i class="bi" [class]="sortIcon('createdAt')"></i>
          </th>
          <th>Status</th>
          <th><i class="bi bi-whatsapp text-success"></i> WhatsApp</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of result.items">
          <td><strong>{{ p.name }}</strong></td>
          <td>{{ p.phone || '—' }}</td>
          <td>{{ p.email || '—' }}</td>
          <td>{{ p.createdAt | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="badge" [class.bg-success]="p.isActive" [class.bg-secondary]="!p.isActive">
              {{ p.isActive ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
          <td>
            <span [class]="waStatusClass(p.whatsAppStatus)">
              {{ waStatusLabel(p.whatsAppStatus) }}
            </span>
          </td>
          <td class="actions">
            <button class="btn btn-sm btn-outline-primary" title="Editar" (click)="openModal(p)">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-outline-danger" title="Excluir" (click)="delete(p)">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="result.items.length === 0">
          <td colspan="7" class="empty-row">
            <i class="bi bi-people"></i> Nenhum paciente encontrado
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination
      [result]="result"
      (pageChange)="onPageChange($event)"
      (sizeChange)="onSizeChange($event)">
    </app-pagination>
  </div>

</div>

<!-- ============================================================
     MODAL — CADASTRO / EDIÇÃO DE PACIENTE
     ============================================================ -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()"></div>
<div class="modal-wrap"    *ngIf="showModal">
  <div class="modal-box">

    <div class="modal-box-header">
      <h5 class="mb-0">{{ editingId ? 'Editar Paciente' : 'Novo Paciente' }}</h5>
      <button class="btn-x" (click)="closeModal()">✕</button>
    </div>

    <div class="modal-box-body">
      <div class="row g-3">

        <div class="col-12">
          <label class="form-label">Nome Completo *</label>
          <input type="text" class="form-control" [(ngModel)]="form.name"
                 placeholder="Nome do paciente">
        </div>

        <div class="col-md-6">
          <label class="form-label">Telefone *</label>
          <input type="tel" class="form-control" [(ngModel)]="form.phone"
                 (input)="onPhoneInput($event)"
                 placeholder="(11) 98765-4321" maxlength="15">
        </div>

        <div class="col-md-6">
          <label class="form-label">E-mail</label>
          <input type="email" class="form-control" [(ngModel)]="form.email"
                 placeholder="paciente@email.com">
        </div>

        <div class="col-md-6">
          <label class="form-label">Confirmar E-mail</label>
          <input type="email" class="form-control"
                 [class.is-invalid]="form.emailConfirm && form.email !== form.emailConfirm"
                 [class.is-valid]="form.email && form.email === form.emailConfirm"
                 [(ngModel)]="form.emailConfirm" placeholder="Repita o e-mail">
          <div class="invalid-feedback" *ngIf="form.emailConfirm && form.email !== form.emailConfirm">
            Os e-mails não conferem.
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control" [(ngModel)]="form.cpf"
                 (input)="onCpfInput($event)"
                 placeholder="000.000.000-00" maxlength="14">
        </div>

        <div class="col-md-6">
          <label class="form-label">Data de Nascimento</label>
          <div class="date-input-wrapper">
            <input #birthDateInput type="text" class="form-control"
                   [(ngModel)]="birthDateDisplay"
                   (input)="onBirthDateInput($event)"
                   placeholder="dd/mm/aaaa"
                   maxlength="10">
            <button type="button" class="date-picker-btn" (click)="toggleBirthDatePicker()">
              <i class="bi bi-calendar3"></i>
            </button>
          </div>

          <!-- Overlay para fechar ao clicar fora -->
          <div class="datepicker-overlay" *ngIf="showBirthDatePicker" (click)="showBirthDatePicker = false"></div>

          <!-- Datepicker Popup -->
          <div class="datepicker-popup" *ngIf="showBirthDatePicker"
               [style.top]="birthPickerTop"
               [style.left]="birthPickerLeft"
               (click)="$event.stopPropagation()">
            <div class="datepicker-header">
              <button type="button" class="btn-nav" (click)="birthPickerPreviousMonth()">
                <i class="bi bi-chevron-left"></i>
              </button>
              <span class="datepicker-month">{{ getBirthPickerMonthYear() | titlecase }}</span>
              <button type="button" class="btn-nav" (click)="birthPickerNextMonth()">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>

            <div class="datepicker-weekdays">
              <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
            </div>

            <div class="datepicker-days">
              <div
                *ngFor="let date of birthPickerDays"
                class="datepicker-day"
                [class.other-month]="!birthPickerIsCurrentMonth(date)"
                [class.today]="birthPickerIsToday(date)"
                [class.selected]="birthPickerIsSelected(date)"
                (click)="birthPickerSelectDate(date)">
                {{ date.getDate() }}
              </div>
            </div>

            <div class="datepicker-footer">
              <button type="button" class="btn btn-sm btn-link" (click)="birthPickerSelectToday()">
                Hoje
              </button>
            </div>
          </div>
        </div>

        <!-- Endereço -->
        <div class="col-12 mt-2">
          <h6 class="text-muted mb-0"><i class="bi bi-geo-alt me-1"></i>Endereço</h6>
        </div>
        <div class="col-md-8">
          <label class="form-label">Endereço</label>
          <input type="text" class="form-control" [(ngModel)]="form.address" placeholder="Rua, Avenida...">
        </div>
        <div class="col-md-4">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [(ngModel)]="form.number" placeholder="123">
        </div>
        <div class="col-md-6">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="form.neighborhood" placeholder="Centro">
        </div>
        <div class="col-md-6">
          <label class="form-label">Complemento</label>
          <input type="text" class="form-control" [(ngModel)]="form.complement" placeholder="Apto, Sala...">
        </div>
        <div class="col-md-5">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="form.city" placeholder="São Paulo">
        </div>
        <div class="col-md-3">
          <label class="form-label">Estado</label>
          <input type="text" class="form-control" [(ngModel)]="form.state" placeholder="SP" maxlength="2">
        </div>
        <div class="col-md-4">
          <label class="form-label">CEP</label>
          <input type="text" class="form-control" [(ngModel)]="form.zipCode" placeholder="00000-000" maxlength="9">
        </div>

        <div class="col-12">
          <label class="form-label">Observações</label>
          <textarea class="form-control" rows="3" [(ngModel)]="form.notes"
                    placeholder="Informações adicionais sobre o paciente..."></textarea>
        </div>

        <!-- WhatsApp confirmation — apenas no cadastro -->
        <div class="col-12" *ngIf="!editingId">
          <div class="form-check form-switch mt-1">
            <input class="form-check-input" type="checkbox" id="chkWa"
                   [(ngModel)]="form.sendWhatsAppConfirmation">
            <label class="form-check-label" for="chkWa">
              <i class="bi bi-whatsapp text-success me-1"></i>
              Enviar mensagem de confirmação via WhatsApp
            </label>
          </div>
          <small class="text-muted ms-4" *ngIf="form.sendWhatsAppConfirmation">
            O paciente receberá uma mensagem pedindo para adicionar o número aos contatos e confirmar o cadastro.
          </small>
        </div>

      </div>
    </div>

    <div class="modal-box-footer">
      <button class="btn btn-secondary" (click)="closeModal()">Cancelar</button>
      <button class="btn btn-primary" (click)="save()" [disabled]="saving || !emailsMatch">
        <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
        {{ editingId ? 'Salvar Alterações' : 'Salvar' }}
      </button>
    </div>

  </div>
</div>
